import { render } from "./PaginationItemTable.vue?vue&type=template&id=8bd570fa&scoped=true"
import script from "./PaginationItemTable.vue?vue&type=script&lang=js"
export * from "./PaginationItemTable.vue?vue&type=script&lang=js"

import "./PaginationItemTable.vue?vue&type=style&index=0&id=8bd570fa&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd570fa"]])

export default __exports__